<template>
  <div>
    <b-container fluid>
      <b-card no-body>
        <b-overlay
          :show="isLoading"
          rounded="sm"
        >
          <div class="m-2">
            <b-row>
              <b-col
                cols="6"
              >
                <b-form-group
                  label-for="input-default"
                >
                  <v-select
                    v-model="filter.subjectId"
                    placeholder="Học phần"
                    :options="subjects"
                    :reduce="option => option.value"
                  />
                </b-form-group>
              </b-col>
              <b-col
                cols="6"
                class="text-right"
              >
                <b-form-group>
                  <b-button
                    variant="primary"
                    @click="btnSearchClick()"
                  >
                    <feather-icon
                      icon="SearchIcon"
                      class="align-text-top"
                    />
                    Tìm kiếm
                  </b-button>
                  <b-button
                    class="ml-1"
                    v-if="creatable && SHOW_QB_ESSAY_QUESTION === '1'"
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    variant="info"
                    @click="importQuestion"
                  >
                    <span class="text-nowrap text-right">
                      <feather-icon icon="PlusIcon" /> Import câu hỏi file excel
                    </span>
                  </b-button>
                  <b-button
                    class="ml-1"
                    v-if="creatable"
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    variant="info"
                    @click="importQuestionFileWord"
                  >
                    <span class="text-nowrap text-right">
                      <feather-icon icon="PlusIcon" /> Import câu hỏi file word
                    </span>
                  </b-button>
                  <b-button
                    class="ml-1"
                    v-if="creatable"
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    variant="success"
                    @click="onCreate"
                  >
                    <span class="text-nowrap text-right">
                      <feather-icon icon="PlusIcon" /> Thêm mới
                    </span>
                  </b-button>
                  <b-button
                    class="ml-1"
                    v-if="deletable"
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    variant="danger"
                    @click="onDeleteList"
                  >
                    <span class="text-nowrap text-right">
                      <feather-icon icon="XOctagonIcon" /> Xóa câu hỏi
                    </span>
                  </b-button>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12">
                <div class="d-flex align-items-center mb-1 mt-0">
                  <span class="text-nowrap"> Hiển thị {{ filter.itemsPerPage * (filter.currentPage-1) +1 }}
                    đến {{ filter.itemsPerPage * (filter.currentPage) }} &nbsp; của {{ totalRows }} bản ghi
                  </span>
                </div>
                <vue-good-table
                  mode="remote"
                  :columns="columns"
                  :rows="dataSources"
                  :pagination-options="paginationOptions"
                  :total-rows="totalRows"
                  :select-options="{ enabled: true, selectOnCheckboxOnly: true, selectionText: 'Câu hỏi được chọn', clearSelectionText: 'Bỏ chọn' }"
                  @on-selected-rows-change="selectionChanged"
                  @on-page-change="onPageChange"
                  @on-column-filter="onColumnFilter"
                  @on-per-page-change="onPerPageChange"
                >
                  <div
                    slot="emptystate"
                    style="text-align: center; font-weight: bold"
                  >
                    Không có bản ghi nào !
                  </div>
                  <template
                    slot="table-row"
                    slot-scope="props"
                  >
                    <span v-if="props.column.field === 'stt'">
                      {{ props.row.originalIndex + 1 }}
                    </span>
                    <span v-if="props.column.field === 'status'">
                      {{ props.row.status === 1 ? 'Đang hoạt động' : 'Không hoạt động' }}
                    </span>
                    <span v-else-if="props.column.field === 'action'">
                      <b-dropdown right variant="success" no-caret size="sm">
                        <template #button-content>
                          <feather-icon
                            icon="MoreHorizontalIcon"
                            class="align-middle text-body"
                          />
                        </template>
                        <b-dropdown-item
                          v-if="updatable"
                          v-b-modal.saveModal
                          variant="primary"
                          class="btn-icon"
                          size="sm"
                          @click="onEdit(props.row)"
                        >
                          <feather-icon icon="Edit2Icon"/> Chỉnh sửa câu hỏi
                        </b-dropdown-item>
                        <b-dropdown-item
                          variant="info"
                          class="btn-icon"
                          size="sm"
                          @click="listAnswers(props.row)"
                        >
                          <feather-icon icon="ListIcon"/> Danh sách câu trả lời
                        </b-dropdown-item>
                        <b-dropdown-item
                          v-if="deletable"
                          variant="danger"
                          class="btn-icon"
                          size="sm"
                          @click="onDelete(props.row)"
                        >
                          <feather-icon icon="TrashIcon"/> Xóa câu hỏi
                        </b-dropdown-item>
                      </b-dropdown>
                    </span>
                    <!-- Column: Common -->
                    <span v-else>{{ props.formattedRow[props.column.field] }}</span>
                  </template>
                  <!-- pagination -->
                  <template
                    slot="pagination-bottom"
                    slot-scope="props"
                  >
                    <div class="d-flex justify-content-between flex-wrap">
                      <div class="d-flex align-items-center mb-0 mt-1">
                        <span class="text-nowrap"> Hiển thị {{ filter.itemsPerPage * (filter.currentPage-1) +1 }}
                          đến {{ filter.itemsPerPage * (filter.currentPage) }} &nbsp; của {{ totalRows }} bản ghi
                        </span>
                      </div>
                      <div class="d-flex align-items-center mb-0 mt-1">
                        <span class="text-nowrap"> Hiển thị </span>
                        <b-form-select
                          v-model="filter.itemsPerPage"
                          :options="itemsPerPageOptions"
                          class="mx-1"
                          @input="(value) => props.perPageChanged({ currentPerPage: value })"
                        />
                        <span class="text-nowrap"> bản ghi/trang</span>
                      </div>
                      <div>
                        <b-pagination
                          :value="1"
                          :total-rows="totalRows"
                          :per-page="filter.itemsPerPage"
                          class="mt-1 mb-0"
                          @input="(value) => props.pageChanged({ currentPage: value })"
                        />
                      </div>
                    </div>
                  </template>
                </vue-good-table>
              </b-col>
            </b-row>
          </div>
        </b-overlay>
      </b-card>
    </b-container>
    <b-modal
      ref="modal-add-question-and-answers"
      id="modal-add-question-and-answers"
      centered
      size="xl"
      title="Thêm câu hỏi"
      :hide-footer=true
      no-close-on-backdrop
    >
      <AddQuestionAndAnswer :param-view-t-l="SHOW_QB_ESSAY_QUESTION === '1'"/>
    </b-modal>
    <Save
      :data-form="currentDataSource"
      @succeed="onSucceed"
    />
    <b-modal
      ref="modal-answers"
      id="modal-answers"
      centered
      size="xl"
      :title="`Danh sách câu trả lời cho câu hỏi: ${dataSendClass.name}`"
      :hide-footer=true
      no-close-on-backdrop
    >
      <AnswerIndex :qb-question-id="dataSendClass.id"/>
    </b-modal>
    <b-modal
      ref="modal-multiple-choice-answers"
      id="modal-multiple-choice-answers"
      centered
      size="xl"
      :title="`Danh sách câu trả lời cho câu hỏi trắc nghiệm: ${dataSendClass.name}`"
      :hide-footer=true
      no-close-on-backdrop
    >
      <MultipleChoiceAnswerResource :qb-question-id="dataSendClass.id"/>
    </b-modal>
    <b-modal
      ref="modal_import_questions"
      id="modal_import_questions"
      centered
      size="xl"
      :hide-footer=true
      no-close-on-backdrop
    >
      <ImportQuestion :subject-id="subjectId" @succeed="onSucceed"/>
    </b-modal>
    <b-modal
      ref="modal_import_questions_word"
      id="modal_import_questions_word"
      centered
      size="xl"
      :hide-footer=true
      no-close-on-backdrop
    >
      <ImportQuestionFileWord :subject-id="subjectId" @succeed="onSucceed"/>
    </b-modal>
  </div>
</template>

<script>
import {
  BButton, BCard, BCol, BContainer, BDropdown, BDropdownItem, BFormGroup, BFormSelect, BOverlay, BPagination, BRow,
} from 'bootstrap-vue'
import { VueGoodTable } from 'vue-good-table'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import '@core/scss/vue/libs/vue-good-table.scss'
import Ripple from 'vue-ripple-directive'
import { hasPermissionForResource, isSystemAdmin } from '@/utils'
import { PermissionCode, ResourceCode } from '@/const/code'
import Save from '@/views/exam-question/qb-question/Save.vue'
import vSelect from 'vue-select'
import { getUser } from '@/auth/utils'
import AnswerIndex from '@/views/exam-question/qb-answer/AnswerIndex.vue'
import MultipleChoiceAnswerResource from '@/views/exam-question/qb-multiple-choice-answer/MultipleChoiceAnswerResource.vue'
import ImportQuestion from '@/views/exam-question/qb-question/ImportQuestion.vue'
import AddQuestionAndAnswer from '@/views/exam-question/qb-question/AddQuestionAndAnswer.vue'
import ImportQuestionFileWord from '@/views/exam-question/qb-question/ImportQuestionFileWord.vue'

export default {
  name: 'Index',
  directives: {
    Ripple,
  },
  components: {
    ImportQuestion,
    ImportQuestionFileWord,
    AnswerIndex,
    MultipleChoiceAnswerResource,
    AddQuestionAndAnswer,
    BDropdownItem,
    BDropdown,
    BFormGroup,
    vSelect,
    Save,
    BButton,
    BCard,
    BCol,
    BContainer,
    BFormSelect,
    BOverlay,
    BPagination,
    BRow,
    VueGoodTable,
  },
  data() {
    return {
      isLoading: false,
      filter: {
        currentPage: 1,
        itemsPerPage: 10,
        subjectId: null,
        qbQuestionTypeId: null,
        qbQuestionScaleId: null,
        code: null,
        name: null,
        status: null,
      },
      subjectId: null,
      currentDataSource: undefined,
      paginationOptions: {
        enabled: true,
      },
      filterTemp: {
        currentPage: 1,
        itemsPerPage: 10,
        status: 1,
      },
      itemsPerPageOptions: [10, 20, 30, 50, 80, 100],
      dataSendClass: {},
      selectedMainData: [],
      SHOW_QB_ESSAY_QUESTION: 0,
    }
  },
  computed: {
    ...mapGetters({
      subjects: 'qbQuestion/subjects',
      dataSources: 'qbQuestion/dataSources',
      totalRows: 'qbQuestion/totalRows',
      qbQuestionTypeData: 'qbQuestionType/dataSources',
      qbQuestionScaleData: 'qbQuestionScale/dataSources',
      systemParameters: 'parameter/dataLists',
    }),
    columns() {
      const columns = [
        {
          label: 'Tên câu hỏi',
          field: 'name',
          filterOptions: {
            enabled: true,
            trigger: 'enter',
          },
          sortable: true,
          thClass: 'text-center',
        },
        {
          label: 'Học phần',
          field: 'subjectName',
          sortable: true,
          thClass: 'text-center',
        },
        {
          label: 'Trạng thái',
          field: 'status',
          filterOptions: {
            enabled: true,
            trigger: 'enter',
            filterDropdownItems: [
              { value: 1, text: 'Hoạt động' },
              { value: 0, text: 'Không hoạt động' },
            ],
          },
          sortable: false,
          thClass: 'text-center',
        },
        {
          label: '',
          field: 'action',
          width: '100px',
          sortable: false,
          thClass: 'text-center',
          tdClass: 'text-center',
        },
      ]
      if (this.SHOW_QB_ESSAY_QUESTION !== '0') {
        columns.splice(1, 0,
          {
            label: 'Loại câu hỏi',
            field: 'qbQuestionTypeName',
            filterOptions: {
              enabled: true,
              trigger: 'enter',
            },
            sortable: true,
            thClass: 'text-center',
          },
          {
            label: 'Mức độ câu hỏi',
            field: 'qbQuestionScaleName',
            filterOptions: {
              enabled: true,
              trigger: 'enter',
            },
            sortable: true,
            thClass: 'text-center',
          },
          {
            label: 'Điểm',
            field: 'score',
            sortable: true,
            thClass: 'text-center',
          }
        )
      }
      return columns
    },
    creatable() {
      return isSystemAdmin() || hasPermissionForResource(PermissionCode.CREATE, ResourceCode.QB_QUESTION)
    },
    updatable() {
      return isSystemAdmin() || hasPermissionForResource(PermissionCode.UPDATE, ResourceCode.QB_QUESTION)
    },
    deletable() {
      return isSystemAdmin() || hasPermissionForResource(PermissionCode.DELETE, ResourceCode.QB_QUESTION)
    },
  },
  watch: {
    async resource() {
      await this.onLoad()
    },
  },
  async created() {
    await this.onLoad()
  },
  methods: {
    ...mapMutations({
      setDataSources: 'qbQuestion/SET_DATA_SOURCES',
    }),
    ...mapActions({
      getDataSources: 'qbQuestion/getDataSources',
      deleteDataSource: 'qbQuestion/deleteDataSourceTemp',
      deleteMultiple: 'qbQuestion/deleteMultipleTemp',
      getSubjects: 'qbQuestion/getSubjects',
      getQuestionType: 'qbQuestionType/getDataSources',
      getQuestionScale: 'qbQuestionScale/getDataSources',
      getSystemParameters: 'parameter/getAllData',
    }),
    async onLoad() {
      this.isLoading = true
      try {
        await Promise.all([
          this.getSubjects({ organizationId: getUser().orgId }),
          this.getQuestionType(this.filterTemp),
          this.getQuestionScale(this.filterTemp),
          this.getDataSourcesFromStore(),
          this.getSystemParameters(),
        ])
        this.SHOW_QB_ESSAY_QUESTION = this.systemParameters.find(item => item.code === 'SHOW_QB_ESSAY_QUESTION').value || 0
      } catch (e) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: `[${e.code}] ${e.message}`,
            icon: 'XCircleIcon',
            variant: 'danger',
          },
        })
        this.setDataSources([])
      } finally {
        this.isLoading = false
      }
    },
    async importQuestion() {
      if (this.filter.subjectId === null) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Môn học được để trống!',
            icon: 'InfoIcon',
            variant: 'warning',
          },
        })
        return
      }
      this.subjectId = this.filter.subjectId
      this.$refs.modal_import_questions.show()
    },
    async importQuestionFileWord() {
      if (this.filter.subjectId === null) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Môn học được để trống!',
            icon: 'InfoIcon',
            variant: 'warning',
          },
        })
        return
      }
      this.subjectId = this.filter.subjectId
      this.$refs.modal_import_questions_word.show()
    },
    async btnSearchClick() {
      this.isLoading = true
      try {
        await this.getDataSourcesFromStore()
      } catch (e) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: `[${e.code}] ${e.message}`,
            icon: 'XCircleIcon',
            variant: 'danger',
          },
        })
      } finally {
        this.isLoading = false
      }
    },
    async onDeleteList() {
      if (this.selectedMainData.length < 1) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Vui lòng chọn câu hỏi!',
            icon: 'XCircleIcon',
            variant: 'danger',
          },
        })
        return null
      }
      this.isLoading = true
      try {
        const request = {
          qbQuestionIds: this.selectedMainData,
        }
        const response = await this.deleteMultiple(request)
        if (response) {
          const { isSuccessful, message } = response
          if (isSuccessful) {
            await this.getDataSourcesFromStore()
            this.$toast({
              component: ToastificationContent,
              props: {
                title: message,
                icon: 'CheckIcon',
                variant: 'success',
              },
            })
          } else {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: message,
                icon: 'XCircleIcon',
                variant: 'danger',
              },
            })
          }
        }
      } catch (e) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: `[${e.code}] ${e.message}`,
            icon: 'XCircleIcon',
            variant: 'danger',
          },
        })
      } finally {
        this.isLoading = false
      }
      return null
    },
    onCreate() {
      this.currentDataSource = undefined
      this.$refs['modal-add-question-and-answers'].show()
    },
    listAnswers(data) {
      this.dataSendClass = data
      if (data.qbQuestionTypeCode !== 'TN') {
        this.$refs['modal-answers'].show()
      } else {
        this.$refs['modal-multiple-choice-answers'].show()
      }
    },
    onEdit(dataSource) {
      const {
        rowNum,
        originalIndex,
        vgt_id,
        ...rest
      } = dataSource
      this.currentDataSource = rest
    },
    onDelete(dataSource) {
      this.$swal({
        title: `Bạn chắc chắn muốn xóa câu hỏi <span class="text-danger">${dataSource.name}</span>?`,
        text: 'Câu hỏi sẽ được chuyển vào thùng rác!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: '<i class="fa-solid fa-check"></i> Đồng ý',
        cancelButtonText: '<i class="fa-solid fa-times"></i> Hủy',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(async result => {
        if (result.value) {
          this.isLoading = true
          try {
            const response = await this.deleteDataSource(dataSource.id)
            if (response) {
              const { isSuccessful, message } = response
              if (isSuccessful) {
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: message,
                    icon: 'CheckIcon',
                    variant: 'success',
                  },
                })
                try {
                  await this.getDataSourcesFromStore()
                } catch (e) {
                  this.$toast({
                    component: ToastificationContent,
                    props: {
                      title: `[${e.code}] ${e.message}`,
                      icon: 'XCircleIcon',
                      variant: 'danger',
                    },
                  })
                }
              } else {
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: message,
                    icon: 'XCircleIcon',
                    variant: 'danger',
                  },
                })
              }
            }
          } catch (e) {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: `[${e.code}] ${e.message}`,
                icon: 'XCircleIcon',
                variant: 'danger',
              },
            })
          } finally {
            this.isLoading = false
          }
        }
      })
    },
    updateParams(newProps) {
      this.filter = { ...this.filter, ...newProps }
    },
    selectionChanged(params) {
      this.selectedMainData = params ? params.selectedRows.map(e => e.id) : []
    },
    async onPageChange(param) {
      this.updateParams({ currentPage: param.currentPage })
      await this.getDataSourcesFromStore()
    },
    async getDataSourcesFromStore() {
      this.isLoading = true
      try {
        await this.getDataSources(this.filter)
      } catch (e) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: `[${e.code}] ${e.message}`,
            icon: 'XCircleIcon',
            variant: 'danger',
          },
        })
      } finally {
        this.isLoading = false
      }
    },
    async onPerPageChange(param) {
      this.updateParams({ currentPage: 1, itemsPerPage: param.currentPerPage })
      await this.getDataSourcesFromStore()
    },
    async onColumnFilter(param) {
      const { columnFilters } = param
      if (Object.hasOwn(columnFilters, 'name')) this.updateParams({ name: columnFilters.name })
      if (Object.hasOwn(columnFilters, 'qbQuestionTypeName')) this.updateParams({ qbQuestionTypeName: columnFilters.qbQuestionTypeName })
      if (Object.hasOwn(columnFilters, 'qbQuestionScaleName')) this.updateParams({ qbQuestionScaleName: columnFilters.qbQuestionScaleName })
      await this.getDataSourcesFromStore()
    },
    async onSucceed() {
      await this.getDataSourcesFromStore()
    },
    getStatusName(id) {
      return this.status.find(status => status.value === id).label
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-good-table.scss';
</style>
